// removed by extract-text-webpack-plugin
module.exports = {"container":"Asj9Q","borders":"_209vg","filter":"_2XSck","sort":"_2q0Tu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/member-header/member-header-desktop.scss
// module id = 1649
// module chunks = 0